import { useCallback, useEffect, useState } from "react";
import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  setPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router";
import GetUser from "../../Controllers/Users/GetUser";
import GetAllSchools from "../../Controllers/Admin/Schools/GetAllSchools";
import { SetLocalStorage } from "../../Controllers/LocalStorage/SetLocalStorage";
import { AuthErrorMessages } from "../../Helpers/ToastMessages";
import { clearLocalStorage } from "../../Controllers/LocalStorage/ClearLocalStorage";

export default function LoginViewModel() {
  const [EmailError, setEmailError] = useState(false);
  const [PasswordError, setPasswordError] = useState(false);
  const [IsCheckError, setIsCheckError] = useState(false);
  const [RememberMe, setRememberMe] = useState(false);
  const [AuthUserObject, setAuthUserObject] = useState({});
  // const [AuthUserObject, setAuthUserObject] = useState({});
  const [DisableForm, setDisableForm] = useState(false);
  const [User, setUser] = useState({
    Email: "",
    Password: "",
  });

  const navigate = useNavigate();

  // Check email validation
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const UIErrorHandling = useCallback(() => {
    let flag = 0;
    if (
      User.Email === "" ||
      User.Email === null ||
      User.Email === undefined ||
      !isValidEmail(User.Email)
    ) {
      setEmailError(true);
      flag++;
    } else {
      setEmailError(false);
    }

    if (
      User.Password === "" ||
      User.Password === null ||
      User.Password === undefined ||
      User.Password.length < 6
    ) {
      setPasswordError(true);
      flag++;
    } else {
      setPasswordError(false);
    }
    return flag;
  }, [User.Email, User.Password]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const SignInUser = async (e) => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();
    if (flag === 0) {
      setDisableForm(true);
      if (RememberMe) {
        await setPersistence(auth, browserLocalPersistence);
      }

      signInWithEmailAndPassword(auth, User.Email, User.Password)
        .then(async (userCredential) => {
          setDisableForm(false);
          const user = userCredential.user;
          const UserData = await GetUser(user?.uid);
          if (UserData.UserType === "admin") {
            clearLocalStorage();
            setAuthUserObject(UserData);
            let resp = await GetAllSchools(user?.uid);
            if (resp[0]) {
              SetLocalStorage("schoolId", resp[0]?.id);
            }
          } else {
            let SchoolID = UserData.SchoolID;
            clearLocalStorage();
            if (SchoolID) {
              SetLocalStorage("schoolId", SchoolID);
            }
          }

          if (user) {
            user.getIdTokenResult().then((idTokenResult) => {
              if (idTokenResult.claims.admin) {
                navigate("/user/super-admin/users");
              }
            });
          }

          if (user.emailVerified === false) {
            navigate("/email-verification");
          } else if (UserData?.IsVerified === 0) {
            navigate("/verification-pending");
          } else if (
            UserData?.IsVerified === 1 &&
            UserData?.UserType === "admin"
          ) {
            navigate("/user/admin/dashboard");
          } else if (
            UserData?.IsVerified === 1 &&
            UserData?.UserType === "teacher"
          ) {
            navigate("/user/teacher/dashboard");
          } else if (
            UserData?.IsVerified === 1 &&
            UserData?.UserType === "student"
          ) {
            navigate("/user/student/dashboard");
          } else if (
            UserData?.IsVerified === 1 &&
            UserData?.UserType === "parent"
          ) {
            navigate("/user/parent/dashboard");
          } else if (UserData.IsVerified === 2) {
            // Account verification rejucted
            // Resend verification request
            navigate("/verification-rejected");
          }
        })
        .catch((error) => {
          setDisableForm(false);
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(errorCode);
          AuthErrorMessages(errorCode);
        });
    }
  };

  return [
    User,
    setUser,
    SignInUser,
    EmailError,
    PasswordError,
    DisableForm,
    RememberMe,
    setRememberMe,
  ];
}
